import React, { Component } from 'react';
import { clearAlerts, setGlobalAlert } from 'actions';
import { connect } from 'react-redux';

import { waitForElement } from 'helpers/page';

class FormTools extends Component {
    state = {
        showToastr: true,
    };

    handleFormSubmit = (formInstance) => {
        const {
            hasPassword,
            onSubmit,
            validationFailed,
        } = this.props;
        const isValid = !(formInstance.isValid() === false);

        if (isValid) {
            onSubmit(formInstance);
            return true;
        }

        validationFailed();
        return false;
    };

    handleFormSuccess = () => {
        this.props.clearAlerts();
    };

    componentDidMount = () => {
        const formScope = `#${this.props.formID}`;

        // After a half second apply form validation
        waitForElement(formScope).then(
            ({ element }) => {
                // Initialize parsley and handle form submits after validation
                $(element).parsley(window.ParsleyConfig)
                    .on('form:submit', this.handleFormSubmit)
                    .on('form:success', this.handleFormSuccess)
                    .on('form:error', function () {
                        // this references the jquery parsley element
                        window.$(this).closest('.form-group').addClass('has-error').append(window.$(this));
                    });
            },
            (/* err */) => {
            },
        );
    };

    // Nothing to output
    render() {
        return null;
    }
}

FormTools.defaultProps = {
    hasPassword: false,
    handleEmailCheck: false,
    onSubmit() {
    },
    validationFailed() {
    },
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps, { setGlobalAlert, clearAlerts })(FormTools);
